import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-exclamation-circle-s",
  "use": "icon-exclamation-circle-s-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-exclamation-circle-s\"><path fill-rule=\"evenodd\" d=\"M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm-.786 5.696c0-.108.089-.196.197-.196h1.178c.108 0 .197.088.197.196v6.679a.197.197 0 01-.197.196h-1.178a.197.197 0 01-.197-.196V6.696zM12 17.5a1.179 1.179 0 010-2.357 1.179 1.179 0 010 2.357z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol